import { AuctionResponse, BidOutcomeResponse, BidResponse } from './auction.response';
import { AuctionState, BidOutcomeState, BidState } from './auction.state';

/** Pure wire → state mappers for the auction endpoints. */

export function mapAuctionResponse(response: AuctionResponse): AuctionState {
  return {
    ...response,
    startsAt: new Date(response.startsAt),
    endsAt: new Date(response.endsAt)
  };
}

export function mapBidResponse(response: BidResponse): BidState {
  return {
    ...response,
    placedAt: new Date(response.placedAt)
  };
}

export function mapBidOutcomeResponse(response: BidOutcomeResponse): BidOutcomeState {
  return {
    ...response,
    endsAt: new Date(response.endsAt)
  };
}
